import { FC, ReactNode } from 'react';
import { Button } from '../ui/button';
import { cn } from 'lib/utils';
import BPIcon from '../icons/BPIcon';

interface BPLinkButtonProps {
  children: ReactNode;
  className?: string;
  onClick?: () => void;
  isExternalLink?: boolean;
  disabled?: boolean;
}

const BPLinkButton: FC<BPLinkButtonProps> = ({
  children,
  className = '',
  onClick = () => {},
  isExternalLink = false,
  disabled = false,
}) => {
  return (
    <Button
      onClick={onClick}
      className={cn(
        'group/button grid gap-1 bg-transparent hover:bg-transparent text-white hover:text-white/50 px-0 fill-white hover:fill-white/50',
        className,
        disabled ? 'pointer-events-none opacity-20' : ''
      )}
    >
      <div className="grid relative grid-cols-[1fr_auto]">
        <div>{children}</div>
        {isExternalLink && <BPIcon icon="external" className="-ml-2" />}
      </div>
      <div className="block relative w-full h-[2px] transition-all bg-gradient-to-r from-white/0 to-white/0 via-white/40 group-hover/button:bg-white/10" />
    </Button>
  );
};

export default BPLinkButton;
